import React from 'react';
import { FaTimes } from 'react-icons/fa';
import '../styles/InventoryEquipment.css';
import '../styles/InventoryAllocation.css';

function money(n) {
  const v = Number(n) || 0;
  return v.toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  });
}

function itemLine(item) {
  if (!item) return '';
  if (typeof item === 'string') return item;
  const qty = item.qty ? `${item.qty}× ` : '';
  const code = item.code ? ` #${item.code}` : '';
  const who = item.assignedTo ? ` · ${item.assignedTo}` : '';
  return `${qty}${item.name}${code}${who}`.trim();
}

function DetailList({ items }) {
  if (!items?.length) return <p>—</p>;
  return (
    <ul className="ial-detail-list">
      {items.map((item) => (
        <li key={itemLine(item)}>{itemLine(item)}</li>
      ))}
    </ul>
  );
}

export default function AllocationDetailModal({
  title,
  subtitle,
  statusLabel,
  staff = [],
  equipment = [],
  inventory = [],
  vehicles = [],
  labourHours = 0,
  labourCost = 0,
  chemicalCost = 0,
  totalCost = 0,
  tasks = [],
  onClose,
  onEdit,
}) {
  return (
    <div className="ieq-overlay" role="dialog" aria-modal="true">
      <div className="ieq-modal ieq-modal--detail">
        <header className="ieq-modal-header">
          <h2>{title}</h2>
          <button
            type="button"
            className="ieq-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </header>
        <div className="ieq-modal-body">
          <div className="ieq-badges">
            {subtitle ? <span className="ieq-code-badge">{subtitle}</span> : null}
            {statusLabel ? (
              <span className="ieq-pill ieq-pill--active">{statusLabel}</span>
            ) : null}
          </div>

          <div className="ial-detail-block">
            <h4>Staff</h4>
            <DetailList items={staff} />
          </div>
          {equipment.length ? (
            <div className="ial-detail-block">
              <h4>Equipment</h4>
              <DetailList items={equipment} />
            </div>
          ) : null}
          {inventory.length ? (
            <div className="ial-detail-block">
              <h4>Inventory</h4>
              <DetailList items={inventory} />
            </div>
          ) : null}
          {vehicles.length ? (
            <div className="ial-detail-block">
              <h4>Vehicles</h4>
              <DetailList items={vehicles} />
            </div>
          ) : null}
          {tasks.length ? (
            <div className="ial-detail-block">
              <h4>Tasks</h4>
              <DetailList items={tasks} />
            </div>
          ) : null}
          <div className="ieq-detail-cards">
            <div className="ieq-detail-card">
              <b>Labour</b>
              <span>
                {labourHours} hrs / {money(labourCost)}
              </span>
            </div>
            <div className="ieq-detail-card">
              <b>Chemicals</b>
              <span>{money(chemicalCost)}</span>
            </div>
            <div className="ieq-detail-card">
              <b>Total cost</b>
              <span>{money(totalCost)}</span>
            </div>
          </div>

          <div className="ieq-modal-footer">
            <button type="button" className="ieq-btn" onClick={onClose}>
              Close
            </button>
            {onEdit ? (
              <button
                type="button"
                className="ieq-btn ieq-btn--primary"
                onClick={onEdit}
              >
                Edit allocation
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
